import { getDefaultLogger } from '@kc-console/core';

import { getRequestUrlData } from './getRequestUrlData';

import type { GetServerSidePropsContext } from 'next';
import type { State } from '@kc-console/context';

interface GuardLoggerParams {
  context: GetServerSidePropsContext;
  guardName: string;
  state: Partial<State>;
  custom?: Record<string, any>;
}

export const getGuardLogger = ({ context, state, guardName, custom = {} }: GuardLoggerParams) => {
  const { href } = getRequestUrlData(context);
  const {
    scope,
    region,
    projectId,
    domainId,
    status,
    userId,
    userName,
    token,
    projectName,
    domainName,
    serviceKeyword,
  } = state;

  const refinedData = {
    user: {
      id: userId || 'unknown',
      username: userName || 'unknown',
      token: token || 'unknown',
      ipAddress: context.req.headers['x-real-ip'] || 'unknown',
    },
    project: {
      id: projectId || 'unknown',
      name: projectName || 'unknown',
    },
    domain: {
      id: domainId || 'unknown',
      name: domainName || 'unknown',
    },
    service: {
      id: serviceKeyword || 'unknown', // ex. hadoop-eco
      scope: scope, // 서비스 스코프 정보 (ex. domain, project)
      status: status, // Status Code (ex. 200, 404)
      region: region || 'unknown',
      host: context.req.headers.host || 'unknown',
      path: context.req.url || 'unknown',
      guard_name: guardName,
    },
    ...custom,
  };

  return getDefaultLogger({
    type: 'server_guard',
    url: href || 'unknown',
    custom: refinedData,
  });
};
